import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/station_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'Station',
    column_type: 'string',
    column_name: 'nameCont',
  },
  eurostar_uic_cont: {
    model_name: 'Station',
    column_type: 'string',
    column_name: 'eurostarUic',
  },
  eurostar_active_eq: {
    column_type: 'boolean',
    model_name: 'Station',
    column_name: 'eurostarActive',
  },
  popular_eq: {
    column_type: 'boolean',
    model_name: 'Station',
    column_name: 'popular',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Station', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Station', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
